import { setObjectiveHeight } from '@/utils/common';
import { AcCardQuestTh, AcQuestType, Quest, SubjectType } from './common.interface';

const defaultJSON = {
	"acCard": {
		"acCardGuid": "4695886c-94fc-46b3-8ce2-9c8eb3e898c0",
		"acCardCardID": "20240306",
		"acCardName": "答题卡20240306",
		"acCardPanes": 1,
		"acCardYJType": 1,
		"acCardStudentCodeType": 1,
		"acCardExamNumber": 8,
		"acCardMissSign": true,
		"acCardHideScore": false,
    "acCardHideOrcode": true,
		"acCardPint": 1,
		"acCardABSet": false,
		"acCardDJType": 0,
		"acCardCreateTime": "0001-01-01 0:00:00",
		// "abPaperModel": {
		// 	"DiffAnswer": false,
		// 	"DiffLayout": false
		// }
	},
	"acCardQuestTh": [
    {
      "fkCardGuid": "53ab28dd-edf2-4671-a2e1-60a0a7fef955",
      "questTh_Guid": "bac1d975-8e2b-4cc8-b742-3f744513ba7e",
      "questTh": "一",
      "questTh_name": "填空题",
      "questTh_type": 2,
      "fkQuestTypeGuid": "12623e85-3ebf-467f-90ab-419da87de467",
      "questTh_score": 20,
      "questTh_sort": 1,
      "questTh_thSetting": "",
      "questTh_thNum": 10,
      "questTh_isSmall": 0,
      "questTh_operation":0,
      "quest_list": [{
        "quest_Guid": "8435e331-f960-4a8e-a1ae-f7892e0de67f",
        "quest_th": "一",
        "quest_sechth": "1.1.1",
        "fkQuestTypeGuid": "223ef6c2-87fd-4231-b6fa-66d5d6e1bdab",
        "quest_score": 5,
        "quest_option": 4,
        "quest_bfscore": 0,
        "quest_bfSetting": "",
        "quest_blank": 1,
        "quest_sort": 10101
      },{
        "quest_Guid": "8435e331-f960-4a8e-a1ae-f7892e0de67f",
        "quest_th": "一",
        "quest_sechth": "1.1.2",
        "fkQuestTypeGuid": "223ef6c2-87fd-4231-b6fa-66d5d6e1bdab",
        "quest_score": 5,
        "quest_option": 4,
        "quest_bfscore": 0,
        "quest_bfSetting": "",
        "quest_blank": 1,
        "quest_sort": 10101
      },{
        "quest_Guid": "8435e331-f960-4a8e-a1ae-f7892e0de67f",
        "quest_th": "一",
        "quest_sechth": "1.2.5",
        "fkQuestTypeGuid": "223ef6c2-87fd-4231-b6fa-66d5d6e1bdab",
        "quest_score": 5,
        "quest_option": 4,
        "quest_bfscore": 0,
        "quest_bfSetting": "",
        "quest_blank": 1,
        "quest_sort": 10101
      }]
    },
    {
		"fkCardGuid": "53ab28dd-edf2-4671-a2e1-60a0a7fef955",
		"questTh_Guid": "bac1d975-8e2b-4cc8-b742-3f744513ba7e",
		"questTh": "三",
		"questTh_name": "解答题奥里给",
		"questTh_type": 3,
		"fkQuestTypeGuid": "7eb74987-3590-493a-9e15-9a7aabec4261",
		"questTh_score": 20,
		"questTh_sort": 1,
		"questTh_thSetting": "",
		"questTh_thNum": 10,
		"questTh_isSmall": 0,
		"questTh_operation":0,
		"quest_list": [{
			"quest_Guid": "8435e331-f960-4a8e-a1ae-f7892e0de67f",
			"quest_th": "三",
			"quest_sechth": "3.1",
			"fkQuestTypeGuid": "223ef6c2-87fd-4231-b6fa-66d5d6e1bdab",
			"quest_score": 5,
			"quest_option": 4,
			"quest_bfscore": 0,
			"quest_bfSetting": "",
			"quest_blank": 1,
			"quest_sort": 10101
		},{
			"quest_Guid": "8435e331-f960-4a8e-a1ae-f7892e0de67f",
			"quest_th": "三",
			"quest_sechth": "3.6.6",
			"fkQuestTypeGuid": "223ef6c2-87fd-4231-b6fa-66d5d6e1bdab",
			"quest_score": 5,
			"quest_option": 4,
			"quest_bfscore": 0,
			"quest_bfSetting": "",
			"quest_blank": 1,
			"quest_sort": 10101
		}]
  },
  {
		"fkCardGuid": "53ab28dd-edf2-4671-a2e1-60a0a7fef955",
		"questTh_Guid": "bac1d975-8e2b-4cc8-b742-3f744513ba7e",
		"questTh": "五",
		"questTh_name": "英语作文题",
		"questTh_type": 4,
		"fkQuestTypeGuid": "39666c5a-3440-40cc-a5f0-490a0cf16a2c",
		"questTh_score": 50,
		"questTh_sort": 1,
		"questTh_thSetting": "",
		"questTh_thNum": 10,
		"questTh_isSmall": 0,
		"questTh_operation":0,
		"quest_list": [{
			"quest_Guid": "8435e331-f960-4a8e-a1ae-f7892e0de67f",
			"quest_th": "五",
			"quest_sechth": "5.7",
			"fkQuestTypeGuid": "223ef6c2-87fd-4231-b6fa-66d5d6e1bdab",
			"quest_score": 5,
			"quest_option": 4,
			"quest_bfscore": 0,
			"quest_bfSetting": "",
			"quest_blank": 1,
			"quest_sort": 10101
		}]
  },
  {
		"fkCardGuid": "55424d32-6f71-4b29-94b0-27a49bb47aab",
		"questTh_Guid": "bac1d975-8e2b-4cc8-b742-3f744513ba7e",
		"questTh": "八",
		"questTh_name": "语文作文题",
		"questTh_type": 5,
		"fkQuestTypeGuid": "55424d32-6f71-4b29-94b0-27a49bb47aab",
		"questTh_score": 100,
		"questTh_sort": 1,
		"questTh_thSetting": "",
		"questTh_thNum": 10,
		"questTh_isSmall": 0,
		"questTh_operation":0,
		"quest_list": [{
			"quest_Guid": "8435e331-f960-4a8e-a1ae-f7892e0de67f",
			"quest_th": "八",
			"quest_sechth": "8.8",
			"fkQuestTypeGuid": "223ef6c2-87fd-4231-b6fa-66d5d6e1bdab",
			"quest_score": 5,
			"quest_option": 4,
			"quest_bfscore": 0,
			"quest_bfSetting": "",
			"quest_blank": 1,
			"quest_sort": 10101
		}]
  },
  {
		"fkCardGuid": "213c56d4-f658-4cca-90a7-06054b5588ce",
		"questTh_Guid": "bac1d975-8e2b-4cc8-b742-3f744513ba7e",
		"questTh": "九",
		"questTh_name": "数学选做题",
		"questTh_type": 6,
		"fkQuestTypeGuid": "213c56d4-f658-4cca-90a7-06054b5588ce",
		"questTh_score": 100,
		"questTh_sort": 1,
		"questTh_thSetting": "",
		"questTh_thNum": 10,
		"questTh_isSmall": 0,
		"questTh_operation":0,
		"quest_list": [{
			"quest_Guid": "8435e331-f960-4a8e-a1ae-f7892e0de67f",
			"quest_th": "九",
			"quest_sechth": "9.1",
			"fkQuestTypeGuid": "223ef6c2-87fd-4231-b6fa-66d5d6e1bdab",
			"quest_score": 5,
			"quest_option": 2,
			"quest_bfscore": 0,
			"quest_bfSetting": "",
			"quest_blank": 1,
			"quest_sort": 10101
		}]
  },{
		"fkCardGuid": "213c56d4-f658-4cca-90a7-06054b5588ce",
		"questTh_Guid": "bac1d975-8e2b-4cc8-b742-3f744513ba7e",
		"questTh": "九",
		"questTh_name": "客观题dsadasd",
		"questTh_type": 6,
		"fkQuestTypeGuid": "2598159f-405a-4836-8730-bd035d35bec3",
		"questTh_score": 100,
		"questTh_sort": 1,
		"questTh_thSetting": "",
		"questTh_thNum": 10,
		"questTh_isSmall": 0,
		"questTh_operation":0,
		"quest_list": [{
			"quest_Guid": "8435e331-f960-4a8e-a1ae-f7892e0de67f",
			"quest_th": "九",
			"quest_sechth": "10.2",
			"fkQuestTypeGuid": "e66d9ba9-eb05-47d8-a0e1-01d1be67c42f",
			"quest_score": 5,
			"quest_option": 4,
			"quest_bfscore": 3,
			"quest_bfSetting": "",
			"quest_blank": 1,
			"quest_sort": 10101
		},{
			"quest_Guid": "8435e331-f960-4a8e-a1ae-f7892e0de67f",
			"quest_th": "九",
			"quest_sechth": "9.3",
			"fkQuestTypeGuid": "13854675-79ff-491d-9c88-6d53f2637088",
			"quest_score": 5,
			"quest_option": 4,
			"quest_bfscore": 2,
			"quest_bfSetting": "",
			"quest_blank": 1,
			"quest_sort": 10101
		}]
  },
],
	"acQuestType":  [
    {
      "questType_Guid": "2598159f-405a-4836-8730-bd035d35bec3",
      "questType_name": "客观题",
      "questinonList": [
        {
          "questType_Guid": "5f44b7cd-ad7e-4834-9553-8108e38d147c",
          "questType_name": "单选"
        },
        {
          "questType_Guid": "e66d9ba9-eb05-47d8-a0e1-01d1be67c42f",
          "questType_name": "多选"
        },
        {
          "questType_Guid": "13854675-79ff-491d-9c88-6d53f2637088",
          "questType_name": "判断"
        }
      ]
    },
    {
      "questType_Guid": "12623e85-3ebf-467f-90ab-419da87de467",
      "questType_name": "填空题",
      "questinonList": []
    },
    {
      "questType_Guid": "7eb74987-3590-493a-9e15-9a7aabec4261",
      "questType_name": "解答题",
      "questinonList": []
    },
    {
      "questType_Guid": "39666c5a-3440-40cc-a5f0-490a0cf16a2c",
      "questType_name": "作文_英",
      "questinonList": []
    },
    {
      "questType_Guid": "55424d32-6f71-4b29-94b0-27a49bb47aab",
      "questType_name": "作文_语",
      "questinonList": []
    },
    {
      "questType_Guid": "213c56d4-f658-4cca-90a7-06054b5588ce",
      "questType_name": "选做题",
      "questinonList": []
    }
  ],
	"acCardHtml": {
		"CardHtmlGuid": "ae16a256-3d2d-4799-82ba-f4f289d01a33",
		"all": "",
		"abType": 0,
		"designText":""
	},
	"delGuid": ""
}


/**
 * 将格式转换成可用的subjects
 * @param roughcastSubjects 原始数据 题库那边传来的原始数据，需要转换成对应的subjects
 */
export const transformSubjects = function transformSubjects (roughcastSubjects: Array<AcCardQuestTh>,acQuestType: any,options: any): any {
 
  roughcastSubjects = roughcastSubjects || [];
  acQuestType = acQuestType || []; //大题题型列表 这里是为了把客观题找出来，因为客观题需要判断小题题型（单选多选和判断）
  let subjectsTypeMap = getSubjectsTypeMap(acQuestType);
  let smallTopicTypeMap = getSmallTopicTypeMap(acQuestType);
  let result: any = [];
  if(typeof roughcastSubjects === 'object') {
    const {ObjectiveModel,ChooseModel,BlankModel,AnswerModel,WriteModel,WriteEnModel} = options;
    // 传过来的是json
    roughcastSubjects.forEach((roughcastSubject: AcCardQuestTh,index: number) => {
      console.log(subjectsTypeMap[roughcastSubject.fkQuestTypeGuid]);
      switch(subjectsTypeMap[roughcastSubject.fkQuestTypeGuid]) {
        case '客观题':
          console.log('客观题');
          result.push(transformObjectSubject(ObjectiveModel,roughcastSubject,smallTopicTypeMap)); //寻找客观题小题题型list
          break;
        case '填空题':
          console.log('2填空题');
          result.push(transformBlankSubject(BlankModel,roughcastSubject))
          break;
          case '解答题':
          console.log('3解答题'); 
          result.push(transformAnswerSubject(AnswerModel,roughcastSubject))
          break;
        case '作文_英':
          console.log('4作文题_英');
          result.push(transformWriteEnSubject(WriteEnModel,roughcastSubject))
          break;
        case '作文_语':
          console.log('5作文题_语');
          result.push(transformWriteSubject(WriteModel,roughcastSubject))
          break;
        case '选做题':
          console.log('6选做题');
          result.push(transformChooseSubject(ChooseModel,roughcastSubject))
          break;
        default:
          console.error('题型出错,questTh_type为未知题型');
      }
    });
    return result;
  } else {
    console.error('json数据转换出错 不是正确的json');
    return []
  }
}

/**
 * 转换成客观题subject
 * @param ObjectiveModel 
 * @param acCardQuestTh 
 */

 function transformObjectSubject(ObjectiveModel: any,acCardQuestTh:AcCardQuestTh,smallTopicTypeMap?:any): any {
  let items:Array<{no: number,score?: number,tType?: number,optionNum?:number,partScore?:number,value?:number}> = [];
  acCardQuestTh.quest_list.forEach((quest: Quest,index: number) => {
    const thArray = quest.quest_sechth.split('.');
    let tType;
    if(smallTopicTypeMap[quest.fkQuestTypeGuid|| 0] == '单选') {
      tType = 1;
    } else if(smallTopicTypeMap[quest.fkQuestTypeGuid|| 0] == '多选') {
      tType = 2;
    } else {
      tType = 3;
    }
    items.push({
      no: Number(thArray[1]) || 0,
      score: quest.quest_score, // 得分
      optionNum: quest.quest_option,// 多少选项
      partScore: Number(quest.quest_bfscore),// 部分得分
      tType: tType // 单选 多选 判断 类型
    })
  })
  let model = {
    th: acCardQuestTh.questTh,
    name: acCardQuestTh.questTh_name,
    type: SubjectType.Objective,
    items:items
  }
  let objectiveSubject = new ObjectiveModel(model);
  // objectiveSubject = await setObjectiveHeight(objectiveSubject);
  return objectiveSubject;
}


/**
 * 转换成填空题subject
 * @param BlankModel 
 * @param acCardQuestTh 
 */

function transformBlankSubject(BlankModel: any,acCardQuestTh:AcCardQuestTh): void {
  let items:Array<{no: number,xth?: number,score?: number,tType?: number,tCount?:number,columnCount?:number,value?:number}> = [];
  acCardQuestTh.quest_list && acCardQuestTh.quest_list.forEach((quest: Quest,index: number) => {
  const thArray = quest.quest_sechth.split('.')
    items.push({
      no: Number(thArray[1]) || 0,
      // xth:  Number(thArray[2]) || 0,
      xth:( BlankModel.xThType['①'] && BlankModel.xThType['①'][Number(thArray[2])-1]) || 0,
      score: quest.quest_score,
      tCount: Number(quest.quest_blank),// 每题多少空
      columnCount: 2. //每行多少空 题库那边目前不支持，所以默认每行2空
    })
  })
  let model = {
    th: acCardQuestTh.questTh,
    name: acCardQuestTh.questTh_name,
    //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
    type: SubjectType.Blank,
    items:items
  }
  const blankSubject = new BlankModel(model);
  return blankSubject;
}

/**
 * 转换成解答题
 * @param AnswerModel 
 * @param acCardQuestTh 
 */

function transformAnswerSubject(AnswerModel: any,acCardQuestTh:AcCardQuestTh): void {
  let items:Array<{no: number,xth?: number|string,score?: number,tType?: number,columnCount?:number,value?:number}> = [];
  acCardQuestTh.quest_list && acCardQuestTh.quest_list.forEach((quest: Quest,index: number) => {
  const thArray = quest.quest_sechth.split('.')
    items.push({
      no: Number(thArray[1]) || 0,
      xth:  Number(thArray[2]) || 0,
      score: quest.quest_score,
    })
  })
  let model = {
    th: acCardQuestTh.questTh,
    name: acCardQuestTh.questTh_name,
    //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
    type: SubjectType.Answer,
    items:items
  }
  const answerSubject = new AnswerModel(model);
  return answerSubject;
}

/**
 * 转换成英语作文题目
 * @param WriteEnModel 
 * @param acCardQuestTh 
 */

function transformWriteEnSubject(WriteEnModel: any,acCardQuestTh:AcCardQuestTh): void {
  let items:Array<{no: number,xth?: number,score?: number,tType?: number,columnCount?:number,value?:number}> = [];
  // acCardQuestTh.quest_list && acCardQuestTh.quest_list.forEach((quest: Quest,index: number) => {
  //   items.push({
  //     no: Number(thArray[1]) || 0,
  //   })
  // })
  const thItem:any = (acCardQuestTh.quest_list && acCardQuestTh.quest_list[0]) || [];
  const thArray = thItem.quest_sechth.split('.');
  let model = {
    th: acCardQuestTh.questTh,
    name: acCardQuestTh.questTh_name,
    //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
    type: SubjectType.writeEn,
    start: Number(thArray[1]),
    rowCount: 8, // 英语作文题默认8行
    totalScore: acCardQuestTh.questTh_score
  }
  const writeEnSubject = new WriteEnModel(model);
  return writeEnSubject;
}

/**
 * 转换成语文作文题
 * @param WriteModel 
 * @param acCardQuestTh 
 */

function transformWriteSubject(WriteModel: any,acCardQuestTh:AcCardQuestTh): void {
  const thItem: any = (acCardQuestTh.quest_list && acCardQuestTh.quest_list[0]) || [];
  const thArray = thItem.quest_sechth.split('.');
  let model = {
    th: acCardQuestTh.questTh,
    name: acCardQuestTh.questTh_name,
    //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
    type: SubjectType.write,
    start: Number(thArray[1]),
    wordNum: 800, // 语文作文题默认800字数
    totalScore: acCardQuestTh.questTh_score
  }
  const writeSubject = new WriteModel(model);
  return writeSubject;
}

/**
 * 转换成选做题
 * @param ChooseModel 
 * @param acCardQuestTh 
 */

function transformChooseSubject(ChooseModel: any,acCardQuestTh:AcCardQuestTh): void {
  const thItem: any = (acCardQuestTh.quest_list && acCardQuestTh.quest_list[0]) || [];
  const thArray = thItem.quest_sechth.split('.') || [];
  let model = {
    th: acCardQuestTh.questTh,
    name: acCardQuestTh.questTh_name,
    //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
    type: SubjectType.Choose,
    start: Number(thArray[1]),
    end: Number(thArray[1]) + (thItem && {quest_option: 0}).quest_option,
    score: acCardQuestTh.questTh_score
  }
  debugger;
  const ChooseSubject = new ChooseModel(model);
  return ChooseSubject;
}


function findObjectiveQuestinonList(acQuestType: Array<AcQuestType>): any {
  acQuestType.forEach((typeItem: AcQuestType,index: Number) => {
    typeItem.questinonList
  })
}

/**
 * 判断大题题型
 * @param target 
 */
function getSubjectsTypeMap(acQuestType: Array<AcQuestType>): any {
  let result: any = {};
  acQuestType.forEach((item: AcQuestType) => {
    result[item.questType_Guid] = item.questType_name;
  });
  return result;
}

/**
 * 判断客观题小题题型（单选 多选 判断）
 * @param target 
 */
function getSmallTopicTypeMap(acQuestType: Array<AcQuestType>): any {
  let result: any = {};
  acQuestType.forEach((item: AcQuestType) => {
    if(item.questType_name == '客观题') {
      item.questinonList && item.questinonList.forEach((questItem) => {
        result[questItem.questType_Guid] = questItem.questType_name;
      })
    }
  });
  return result;
}
